/*
  This example requires some changes to your config:
  
  ```
  // tailwind.config.js
  module.exports = {
    // ...
    plugins: [
      // ...
      require('@tailwindcss/forms'),
    ],
  }
  ```
*/
import { BookmarkIcon, FireIcon } from "@heroicons/react/24/outline"
import { BarsArrowUpIcon } from "@heroicons/react/24/solid"
import clsx from "clsx"
import useUser from "hooks/useUser"
import Link from "next/link"
import { useRouter } from "next/router"

export default function DiscoverTabs() {
  const user = useUser()
  const router = useRouter()

  const walletInParam = router?.query?.identifier?.[0] || ""

  const usersWallet = "wallet_address" in user ? user.wallet_address : ""

  console.log("WALLET IDENTIFIER", router)

  const pageIdentifier = router?.query?.identifier || user?.id

  const tabs = [
    {
      name: "Recent",
      href: "/discover/feed/recent/paragraph",
      icon: BarsArrowUpIcon,
      current: router.asPath.includes("recent"),
    },
    {
      name: "Trending",
      href: "/discover/feed/trending/paragraph",
      icon: FireIcon,
      current: router.asPath.includes("trending"),

      children: [
        {
          name: "Trending on Paragraph",
          href: "/discover/feed/trending/paragraph",
          current: router.asPath.includes("trending/paragraph"),
        },
        {
          name: "Trending on Farcaster",
          href: "/discover/feed/trending/farcaster",
          current: router.asPath.includes("trending/farcaster"),
        },
      ],
    },
    {
      name: "For You",
      href: `/discover/feed/for-you/subscriptions/${pageIdentifier || ""}`,
      icon: BookmarkIcon,
      current: router.asPath.includes("for-you"),
      children: [
        {
          name: "Your Subscriptions",
          href: "/discover/feed/for-you/subscriptions/" + pageIdentifier || "",
          current: router.asPath.includes("for-you/subscriptions"),
        },
        {
          name: "Following on Farcaster",
          href:
            "/discover/feed/for-you/farcaster/" + walletInParam ||
            usersWallet ||
            "",
          current: router.asPath.includes("for-you/farcaster"),
        },
      ],
    },
  ]

  const currentTab = tabs.find((tab) => tab.current)

  return (
    <div>
      <div className="">
        <div className="border-b border-gray-200">
          <nav
            className="-mb-px justify-center flex space-x-8"
            aria-label="Tabs"
          >
            {tabs.map((tab) => (
              <Link
                key={tab.name}
                href={tab.href}
                aria-current={tab.current ? "page" : undefined}
                className={clsx(
                  tab.current
                    ? "border-blue-500 text-blue-600"
                    : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300",
                  "group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm"
                )}
              >
                <tab.icon
                  className={clsx(
                    tab.current
                      ? "text-blue-500"
                      : "text-gray-400 group-hover:text-gray-500",
                    "-ml-0.5 mr-2 h-5 w-5"
                  )}
                  aria-hidden="true"
                />
                <span>{tab.name}</span>
              </Link>
            ))}
          </nav>
        </div>

        {currentTab?.children !== undefined && (
          <div className="border-b border-gray-200">
            <nav
              className="-mb-px justify-center flex space-x-8 py-4"
              aria-label="Tabs"
            >
              <div>
                <div className="">
                  <nav className="flex space-x-4" aria-label="Tabs">
                    {currentTab?.children?.map((tab) => (
                      <Link
                        key={tab.name}
                        href={tab.href}
                        className={clsx(
                          tab.current
                            ? "bg-blue-100 text-blue-700"
                            : "text-gray-500 hover:text-gray-700",
                          "px-3 py-2 font-medium text-sm rounded-md"
                        )}
                        aria-current={tab.current ? "page" : undefined}
                      >
                        {tab.name}
                      </Link>
                    ))}
                  </nav>
                </div>
              </div>
            </nav>
          </div>
        )}
      </div>
    </div>
  )
}
